import React from "react";
import { ToolNavigationItem } from "../../../models/navigation/ToolNavigationItem";
import { isNullOrWhiteSpace } from "../../../shared/string";
import SanityLink, { renderLinkTitle } from "../../SanityLink";

interface Props extends ToolNavigationItem {
  fontClass: string;
}

export const ToolLink = ({ fontClass, link, title }: Props) =>
  link ? (
    <SanityLink
      {...link}
      className={`${fontClass} inline-flex justify-between items-center inherit font-bold no-underline hover:text-brand-primary-80 focus:shadow-outline focus:outline-none`}
    >
      {!isNullOrWhiteSpace(title) ? title : renderLinkTitle(link)}
    </SanityLink>
  ) : null;

